import styled from '@emotion/styled';
import { reviews } from '../reviews';

export const ReviewsStyled = styled.section`
    color: ${({ theme }) => theme.colors.yellow3};
    margin-top: 40px;
    div {
        padding: 40px 24px;
        background: #fcfcfc;
        margin-bottom: 20px;
        border: 1px solid #98dbf8;
        border-radius: 15px;
    }
    @media ${({ theme }) => theme.device.laptop} {
        margin-top: 64px;
    }
`;

export const Reviews: React.FC = () => {
    return (
        <ReviewsStyled>
            {reviews.map((review: { name: string; review: string }) => {
                return (
                    <div key={review.name}>
                        <p>{review.name}</p>
                        <p>{review.review}</p>
                    </div>
                );
            })}
        </ReviewsStyled>
    );
};
